import React, { useEffect, useContext, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styles from './StripeSuccess.module.css';
import { AuthContext } from '../Providers/AuthContext';

function StripeSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userProfile, updateProfile, accountType } = useContext(AuthContext);
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    // Get Stripe session ID from URL parameters
    const stripeSessionId = searchParams.get('session_id');
    if (stripeSessionId) {
      setSessionId(stripeSessionId);
    }
  }, [searchParams]);

  useEffect(() => {
    // In production, premium status should be set via Stripe webhook
    // This is a temporary client-side update for testing
    const updatePremiumStatus = async () => {
      if (userProfile && accountType === 'real' && !userProfile.isPremium) {
        try {
          const updatedProfile = {
            ...userProfile,
            isPremium: true,
            premiumSince: new Date()
          };
          await updateProfile(updatedProfile);
        } catch (error) {
        }
      }
    };

    // Small delay to ensure payment is processed
    const timer = setTimeout(updatePremiumStatus, 1000);
    return () => clearTimeout(timer);
  }, [userProfile, accountType, updateProfile]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.icon}>✅</div>
        <h1 className={styles.title}>Welcome to Premium!</h1>
        <p className={styles.subtitle}>
          Your payment was successful and your account has been upgraded.
        </p>

        <div className={styles.features}>
          <h2 className={styles.featuresTitle}>You now have access to:</h2>
          <div className={styles.featuresList}>
            <div className={styles.feature}>
              <span className={styles.featureIcon}>📜</span>
              <span>Complete game history and replay functionality</span>
            </div>
            <div className={styles.feature}>
              <span className={styles.featureIcon}>📊</span>
              <span>Advanced analytics and statistics</span>
            </div>
            <div className={styles.feature}>
              <span className={styles.featureIcon}>🎓</span>
              <span>Exclusive courses and pro strategies</span>
            </div>
          </div>
        </div>

        <button
          className={styles.continueButton}
          onClick={() => navigate('/')}
        >
          Continue to Zodiac Chess
        </button>

        <p className={styles.note}>
          Note: It may take a few moments for all premium features to become available.
        </p>

        {sessionId && (
          <div className={styles.sessionInfo}>
            <p className={styles.sessionLabel}>Transaction ID:</p>
            <p className={styles.sessionId}>{sessionId}</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default StripeSuccess;
